import { Modal } from "antd";
import BtnEditSvg from "../Button/btnEditSvg";
import { useState } from "react";
import EmployeeEmploymentStatus from "../EmployeementStatus";
import Loader from "../../loader/loader";

import WeeklyPFAddSinglePopup from "./WeeklyPFAddPopup";
import ProvidentFundStatus from "../ProvidentFundStatus";

const ProvidentFundPopup = ({ data }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };
  
    return (
      <>
        <button onClick={showModal} className="mt-4 mr-2">
          <BtnEditSvg size={25} />
        </button>
        <Modal
          title="Edit Provident Fund"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {!loading ? (
            <>
              <ProvidentFundStatus
                list={data}
                edit={true}
                setLoading={setLoading}
              />
              <WeeklyPFAddSinglePopup
                list={data}
                setLoading={setLoading}
              />
            </>
          ) : (
            <Loader />
          )}
        </Modal>
      </>
    );
  };

  export default ProvidentFundPopup;
  